import React from "react";
import Lottie from 'react-lottie-player';
import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  container:{
    display: "flex",
    justifyContent:"center"
  }
})
const DynamicRoutingAnimation = props => {
  return (
    <div className={props.classes.container}>
       <Lottie
        loop
        play
        animationData={props.animationJSON}
        style={{ width: props.dimension, height: props.dimension }}
        rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
      />
    </div>
  );
};
export default  withStyles(styles)(DynamicRoutingAnimation);
